import { ObjectPool } from "./ObjectPool";
import { WindowPool } from "./WindowPool";
import { DockableGroup } from "../../Docking/dockableGroup";
import { DockableMonitor } from "../../Docking/dockableMonitor";

const GroupPoolSingleton = new ObjectPool<DockableGroup>("GroupPoolSingleton");
const MonitorPoolSingleton = new ObjectPool<DockableMonitor>("MonitorPoolSingleton");
// Generic list of all windows that the windowService knows about. Contains finsemble windows
const WindowPoolSingleton = new ObjectPool("WindowPoolSingleton");

// Specific pool of dockable windows.
const DockingPoolSingleton = new WindowPool("DockingPoolSingleton");
export { GroupPoolSingleton, WindowPoolSingleton, MonitorPoolSingleton, DockingPoolSingleton };
